var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['base-info-block', _vm.typeClass]},[(_vm.iconName)?_c('MaterialIcon',{staticClass:"mt-[2px] flex-shrink-0",attrs:{"size":17}},[_vm._v(" "+_vm._s(_vm.iconName)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }